import { axiosClient } from "./axiosClient";

export async function getBlogs() {
  const res = await axiosClient.get("/blogs/");
  return res.data;
}

export async function getBlogById(id) {
  const res = await axiosClient.get(`/blogs/${id}/`);
  return res.data;
}

export async function createBlog(payload) {
  const hasFile = payload?.image instanceof File;

  if (hasFile) {
    const form = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (v === undefined || v === null || v === "") return;
      form.append(k, v);
    });

    const res = await axiosClient.post("/blogs/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }

  const res = await axiosClient.post("/blogs/", payload);
  return res.data;
}
